// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__yWOEQ","row":"ProcedureTreatmentSummary_row__2ksBJ"};